import React from 'react';
import { ItemContent, Virtuoso } from 'react-virtuoso';

import { DataList, InterfaceDataList } from '@tiendanube/components';
import Spinner from '../Spinner';
interface VirtualDataListInterface
  extends Pick<
  InterfaceDataList,
  'editMode' | 'onEditMode' | 'bulkAction' | 'selectedRowsId' | 'onSelectRow'
  > {
  isPullable?: boolean;
  data: string[];
  itemContent: ItemContent<string>;
  endReached: (index: number) => void;
  showFooter: boolean;
}

function VirutalDataList({
  editMode,
  onEditMode,
  bulkAction,
  selectedRowsId,
  onSelectRow,
  isPullable,
  data,
  itemContent,
  endReached,
  showFooter,
}: VirtualDataListInterface): JSX.Element {
  const footer = () => <Spinner show={showFooter} />;
  return (
    <DataList
      editMode={editMode}
      onEditMode={onEditMode}
      bulkAction={bulkAction}
      selectedRowsId={selectedRowsId}
      onSelectRow={onSelectRow}
    >
        <Virtuoso
          useWindowScroll
          data={data}
          endReached={endReached}
          itemContent={itemContent}
          components={{
            Footer: footer,
          }}
      />
    </DataList>
  );
}

export default VirutalDataList;
